// Per dataset, and per single file (a lone file is a one-part dataset for these
// ceilings). Check file bytes before reading and footer sizes before decoding.
export const DATASET_LIMITS = Object.freeze({
  files: 256,
  bytes: 128 * 1024 * 1024,
  uncompressedBytes: 256 * 1024 * 1024,
  rows: 500_000,
  cells: 5_000_000,
  discoveredEntries: 10_000,
});
export const DATASET_LIMIT_HELP = 'Per file or dataset: up to 256 files, 25 MB of selected files in the browser, 256 MiB uncompressed data, 500,000 rows, and 5 million cells. All processing stays local.';

/** Caller overrides on top of the defaults. A spread would copy an `undefined`
 * value too, and `x > undefined` is always false — so `{ rows: undefined }`
 * silently switched the row limit OFF. An absent or undefined key keeps the
 * default; anything else must be a number (Infinity is an explicit "no limit"). */
export function mergeLimits(overrides = {}) {
  const limits = { ...DATASET_LIMITS };
  for (const [name, value] of Object.entries(overrides || {})) {
    if (value === undefined) continue;
    if (!Object.hasOwn(DATASET_LIMITS, name)) throw new TypeError(`Unknown dataset limit “${name}”.`);
    if (typeof value !== 'number' || Number.isNaN(value) || value < 0) throw new TypeError(`Dataset limit “${name}” must be a non-negative number.`);
    limits[name] = value;
  }
  return limits;
}

export function checkDatasetLimit(name, value, limits = DATASET_LIMITS) {
  if (value > limits[name]) {
    const amount = name.toLowerCase().includes('bytes') ? `${limits[name] / 1024 / 1024} MiB` : limits[name].toLocaleString();
    const label = { bytes: 'file size', uncompressedBytes: 'uncompressed size', files: 'file count', rows: 'row count', cells: 'cell count', discoveredEntries: 'folder entry count' }[name];
    // Worded for either subject: the same check guards a single file and a dataset.
    throw new Error(`Too large to open: ${label} limit exceeded (${amount}). Nothing was loaded.`);
  }
}
